import { SystemField } from "./system-field";

export class PricebookEntry extends SystemField{
     is_active?:number;
     desc?:string;
     pricebook_id?:string;
     products_id?:string;
     unit_price?:number;
     msrp?:number;
     min_markup_rate?:number;
     markup_rate?:number;
     regular_price?:number;
     is_default?:number;
}
